import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
// Card
import EmploymentInformation from "./EmploymentInformation";
import PositionDetails from "./PositionDetails";
import EmploymentTimeline from "./EmploymentTimeline";
import { useEffect } from "react";
import { CRUDPermissions } from "../../../../Types/Common/Access";

interface EmployeeProfileProps {
  EmpNo: string;
  isAdmin: boolean;
  access: CRUDPermissions;
}

const EmploymentDetails: React.FC<EmployeeProfileProps> = ({
  EmpNo,
  isAdmin,
  access,
}) => {
  return (
    <Row>
      <Col sm="7">
        <EmploymentInformation
          EmpNo={EmpNo}
          isAdmin={isAdmin}
          access={access}
        />
      </Col>
      <Col sm="5">
        <PositionDetails EmpNo={EmpNo} isAdmin={isAdmin} access={access} />
      </Col>
      <Col sm="12">
        <EmploymentTimeline EmpNo={EmpNo} isAdmin={isAdmin} access={access} />
      </Col>
    </Row>
  );
};
export default EmploymentDetails;
